import http from "../http-common";
import IEmployeeDetail from "../types/Employee/EmployeeDetail";
import EmployeeInfo from "../types/Employee/EmployeeInfo";
import EmployeeDetail from "../types/Employee/EmployeeDetail";

class EmployeeService {
  getEmployees(employeeName?: string, employeeId?: string, jobCode?: string | string[], top?: number) {
    const params = new URLSearchParams();
    if (employeeName) params.append('employeeName', employeeName);
    if (employeeId) params.append('employeeId', employeeId);
    if (jobCode) {
      const jobCodes = Array.isArray(jobCode) ? jobCode : [jobCode];
      jobCodes.forEach(code => params.append('jobCode', code));
    }
    if (top !== undefined) params.append('top', String(top));
    return http.get<IEmployeeDetail[]>(`/getEmployees?${params}`);
  }


  getEmployeesByJobCode(jobCode: string, top: number = 50) {
    const params = new URLSearchParams({ jobCode, top: String(top) });
    return http.get<IEmployeeDetail[]>(`/getEmployees?${params}`);
  }

  getNameByID(searchString: string) {
    return http.get<string>(`/getNameByID?q=${searchString}`);
  }

  getUserByEmail(email: string) {
    return http.get<EmployeeDetail>(`/getUserByEmail?q=${email}`);
  }

  /**
   * Finds an employee by any address they are known by — their Quanta sign-in address or their
   * outward-facing Blattner one. Use this for addresses that came from outside the directory (a
   * spreadsheet, an export), where the two forms can differ by more than domain.
   *
   * Returns 404 when no single account unambiguously claims the address.
   */
  findEmployeeByAddress(address: string) {
    return http.get<EmployeeDetail>(`/findEmployeeByAddress?q=${encodeURIComponent(address)}`);
  }

  getEmployeeInfo(email: string) {
    return http.get<EmployeeInfo>(`/getEmployeeInfo?userEmail=${email}`);
  }
}

const employeeServiceInstance = new EmployeeService();

export default employeeServiceInstance;